import { jsx as e } from "react/jsx-runtime";
function r(i) {
  return /* @__PURE__ */ e(
    "svg",
    {
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...i,
      children: /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.0102539 8.9901C0.0102539 4.0248 4.03505 0 9.00035 0C13.9657 0 17.9905 4.0248 17.9905 8.9901C17.9905 13.9554 13.9657 17.9802 9.00035 17.9802C4.03505 17.9802 0.0102539 13.9554 0.0102539 8.9901ZM2.31065 8.9901C2.31065 12.6792 5.31125 15.6798 9.00035 15.6798C12.6895 15.6798 15.6901 12.6792 15.6901 8.9901C15.6901 5.301 12.6895 2.3004 9.00035 2.3004C5.31125 2.3004 2.31065 5.301 2.31065 8.9901ZM6.01055 11.9997V6.0003H12.01V11.9997H6.01055Z"
        }
      )
    }
  );
}
export {
  r as StoppedIcon
};
